import React from 'react';
import {
  Table, TableHead, TableBody, TableRow, TableCell,
  Select, MenuItem, Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useLocalizedMessage } from 'util/useLocalizedMessage';

const useStyles = makeStyles({
  count: {
    color: '#868e96',
    fontSize: '0.85rem',
  },
  clearOption: {
    fontStyle: 'italic',
    color: '#868e96',
  },
});

const BOOL_OPTIONS = [
  { value: '__clear__', labelKey: 'customization.filters.valueEditor.notMapped' },
  { value: 'true',      labelKey: 'customization.filters.valueEditor.true' },
  { value: 'false',     labelKey: 'customization.filters.valueEditor.false' },
];

const BoolMappingEditor = ({ values, onUpdateMapping }) => {
  const classes = useStyles();
  const localizeMessage = useLocalizedMessage();

  const handleChange = (rawValue) => (e) => {
    const val = e.target.value;
    onUpdateMapping(rawValue, val === '__clear__' ? null : val);
  };

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>{localizeMessage('customization.filters.valueEditor.rawValue')}</TableCell>
          <TableCell align="right">{localizeMessage('customization.filters.valueEditor.productCount')}</TableCell>
          <TableCell>{localizeMessage('customization.filters.valueEditor.mapping')}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {values.map((v) => (
          <TableRow key={v.rawValue}>
            <TableCell>
              <Typography variant="body2">{v.rawValue}</Typography>
            </TableCell>
            <TableCell align="right">
              <Typography variant="body2" className={classes.count}>{v.productCount}</Typography>
            </TableCell>
            <TableCell>
              <Select
                value={v.mappedValue || '__clear__'}
                onChange={handleChange(v.rawValue)}
                fullWidth
                variant="outlined"
                margin="dense"
              >
                {BOOL_OPTIONS.map((opt) => (
                  <MenuItem
                    key={opt.value}
                    value={opt.value}
                    className={opt.value === '__clear__' ? classes.clearOption : undefined}
                  >
                    {localizeMessage(opt.labelKey)}
                  </MenuItem>
                ))}
              </Select>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default BoolMappingEditor;
